import { useEffect, useState } from 'react';
import { useStageCropStore } from '../../models/crop-stage-state';
import './scale-stage.less';
import { getTranslateToStageCenter } from '../../utils';

interface IScaleStageProps {
    children?: React.ReactNode;
    stageWidth: number;
    stageHeight: number;
    scale: number;
    isResize: number;
}

const getStageScaleStyle = (stageWidth: number, stageHeight: number, scale: number) => {
    const element = document.getElementById('scale-stage-operate');
    let translatePoint = {
        x: 0,
        y: 0,
    };
    if (element) {
        translatePoint = getTranslateToStageCenter(stageWidth * scale, stageHeight * scale);
    }

    const style = {
        width: `${stageWidth}px`,
        height: `${stageHeight}px`,
        transform: `translate(${-translatePoint.x}px, ${-translatePoint.y}px) scale(${scale})`,
        flexShrink: 0,
        position: 'relative',
        transformOrigin: 'left top',
    } as React.CSSProperties;

    return style;
};

const ScaleStage: React.FC<IScaleStageProps> = ({ children, stageWidth, stageHeight, scale, isResize }) => {
    const [style, setStyle] = useState<React.CSSProperties>({});
    const { isCropStageOperating } = useStageCropStore()((state) => state);

    useEffect(() => {
        if (isCropStageOperating) {
            return;
        }

        const style = getStageScaleStyle(stageWidth, stageHeight, scale);
        setStyle(style);
    }, [isCropStageOperating, scale, stageHeight, stageWidth, isResize]);

    return (
        <div className="l-scaleStage">
            <div id="scale-stage-operate" style={style}>
                {children}
            </div>
        </div>
    );
};

export default ScaleStage;
